// removed by extract-text-webpack-plugin
module.exports = {"tag":"src-components-modules-Tag-style----general-module---tag---2mZkR borderStyle-solid borderColor-smoke fontSize-s borderWidth-1 c-black paddingLeftRight-xs display-inlineFlex justifyContent-center alignItems-center bg-white"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Tag/style/general.module.css
// module id = 742
// module chunks = 71833740541355 256871573202158